<template>
  <v-container>
    <!-- <v-row class="flex justify-center ma-0 ">
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
        <v-text-field
          v-model="search"
          label="Vilken art letar du efter?"
          solo
          filled
          @keydown="sendSearch"
        >
          <template v-slot:append-outer>
            <div style="transform: translateY(-12px);">
              <v-btn color="primary" fab dark @click="sendSearch">
                <v-icon>
                  mdi-magnify
                </v-icon>
              </v-btn>
            </div>
          </template>
        </v-text-field>
      </v-col>
    </v-row> -->
    <v-row v-if="species">
      <v-col cols="12">
        <div class="text-h4">Sökresultat</div>
        <div class="body-3" v-if="species">
          Din sökning gav {{ species.length }} träffar
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="s in species"
        :key="s.id"
        :cols="$_colsWidth"
        class="d-flex child-flex"
      >
        <SpeciesCard class="" :species="s" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Setup from '@/mixins/Setup.js'
import _uniqBy from 'lodash/uniqBy'
import _sortBy from 'lodash/sortBy'
import SpeciesCard from '@/components/SpeciesCard.vue'
import Misc from '@/mixins/Misc.js'
export default {
  name: 'Search',
  mixins: [Setup, Misc],
  components: {
    SpeciesCard
  },
  props: { query: { type: String, required: false } },
  data() {
    return {
      search: ''
    }
  },
  watch: {
    $route: 'setup'
  },
  computed: {
    numberOfHits() {
      return this.species.length
    },
    species() {
      const species = this.$store.getters.getAllSpecies
      const bySweName = species.filter(s =>
        s.name_sve?.toLowerCase().includes(this.query.toLowerCase())
      )
      const byEngName = species.filter(s =>
        s.name_eng?.toLowerCase().includes(this.query.toLowerCase())
      )
      const byLatName = species.filter(s =>
        s.name_lat?.toLowerCase().includes(this.query.toLowerCase())
      )
      const byCategory = species.filter(s =>
        s.category?.toLowerCase().includes(this.query.toLowerCase())
      )
      const bySubCategory = species.filter(s =>
        s.life_group?.toLowerCase().includes(this.query.toLowerCase())
      )
      let res = _uniqBy(
        [
          ...bySweName,
          ...byEngName,
          ...byLatName,
          ...byCategory,
          ...bySubCategory
        ],
        'id'
      )
      return _sortBy(res, 'name_sve')
    }
  },
  methods: {
    setup() {
      this.search = this.query
    },
    sendSearch(e) {
      if (e.type === 'keydown') {
        if (e.key === 'Enter') {
          this.$router.replace({ name: 'Search', query: { q: this.search } })
        }
      } else {
        this.$router.replace({ name: 'Search', query: { q: this.search } })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
